var $117b536bfb1ae554$exports = {};
$117b536bfb1ae554$exports = {
  "Clear search": "\u6E05\u9664\u641C\u7D22"
};
export { $117b536bfb1ae554$exports as default };